import { __ } from '@wordpress/i18n';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

import ItemAppender from './ItemAppender.jsx';
import Style from './Style.jsx';
import { useRef, useEffect } from '@wordpress/element';
import blockJson from './block.json';

export default function Edit( props ) {
	const { attributes, setAttributes, clientId } = props;
	const { blockID } = attributes;

	useEffect( () => {
		setAttributes( { blockID: clientId } );
	}, [ blockID, clientId, setAttributes ] );

	const style = {
		'--accordion-padding-y': '20px',
		'--accordion-padding-x': '20px',
		'--accordion-space-y': '0px',
	};
	const blockProps = useBlockProps( {
		className: `alpha-blocks block-${ blockID }`,
	} );
	const contentRef = useRef( null );

	useEffect( () => {
		if ( contentRef.current && Alpine ) {
			if (
				typeof Alpine?.$data( contentRef.current )?.updateAttributes ===
				'function'
			) {
				Alpine?.$data( contentRef.current )?.updateAttributes(
					attributes
				);
			} else {
			}
		}
	}, [ attributes ] );
	const dataAttribute = {};
	dataAttribute[ 'collapseOtherItems' ] = attributes?.collapseOtherItems;

	return (
		<div { ...blockProps }>
			<window.InspectorGenerator props={ props } blockJson={ blockJson } />
			<div className="alpha-accordions-wrapper">
				<Style
					attributes={ attributes }
					blockID={ blockID }
					setAttributes={ setAttributes }
				/>
				<div
					x-data="accordions"
					className={ `alpha-accordions-2 gap-control-[40px]` }
					id={ blockID }
					ref={ contentRef }
					data-attributes={ JSON.stringify( dataAttribute ) }
				>
					<InnerBlocks
						allowedBlocks={ [ 'alpha-blocks/accordion-item' ] }
						template={ [
							[ 'alpha-blocks/accordion-item', {} ],
							[ 'alpha-blocks/accordion-item', {} ],
						] }
						renderAppender={ () => (
							<ItemAppender
								isDefault
								isLarge
								buttonText="Add Block"
								allowedBlock="alpha-blocks/accordion-item"
								clientId={ clientId }
							/>
						) }
					/>
				</div>
			</div>
		</div>
	);
}
